import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { RelatedEntity } from '~src/spacesPlatform/components/tooltip/RelatedEntity';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { User } from '~src/spacesPlatform/components/tooltip/User';
import { Tags } from '~src/tags/components/tooltips/Tags';

import { IPublishedConnectionInfo } from '../../models/IPublishedConnectionInfo';

export function PublishedConnectionTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const publishedConnectionInfo = content as IPublishedConnectionInfo;
  const projectLink = getProjectLink(publishedConnectionInfo.project, urls);
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField
        markup={props.content.description}
        testId={TooltipDescriptionTestId}
        extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} />}
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
